module.exports = __webpack_public_path__ + "static/media/campus_life.444ba4de.png";